import { CookieConsentVersion } from 'constants/consent';
import { getSystemConfiguration } from 'state/system-configuration/selectors';
import { stateName } from './constants';

const localState = state => state[stateName];

export const getCookieConsentVersion = state => {
  var _getSystemConfigurati;

  return ((_getSystemConfigurati = getSystemConfiguration(state)) === null || _getSystemConfigurati === void 0 ? void 0 : _getSystemConfigurati.cookieConsentVersion) || localState(state).cookieConsentVersion;
};
export const getIsCookieConsentVersion = state => getCookieConsentVersion(state) !== CookieConsentVersion.None;